import React from 'react';

function Error({ statusCode }) {
  return <p>{statusCode ? `An error ${statusCode} occurred on server` : 'An error occurred on client'}</p>;
}
const CustomizeError = ({ statusCode, err }) => {
  if (err) {
    // This will work on both client and server sides in production.
    // Sentry.captureException(err);
  }

  return <Error statusCode={statusCode} />;
};

CustomizeError.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default CustomizeError;
